import React from 'react';

const Step2 = ({ formData, onFileChange, onRemoveFile, files, onBack, onNext }) => {
    const resellerFile = files.upload_reseller_cert;

    // Section 1: Document Requirements Note
    const renderDocumentRequirements = () => (
        <div className="p-3 mb-4" style={{ backgroundColor: '#f2f2f2', borderLeft: '4px solid #125d67' }}>
            <h6 className="dark-color1 fw-bold mb-2" style={{ fontSize: '14px' }}>
                Following documents will be requested to customer for complete:
            </h6>
            <ul className="mb-2 ps-3" style={{ fontSize: '13px', color: '#222' }}>
                <li><strong>1 * Reseller certificate</strong></li>
            </ul>
            <p className="m-0 text-muted" style={{ fontSize: '12px' }}>
                <em>Note: Users can upload documents in PDF, Image, or Word format (.pdf, .jpg, .png, .docx). Maximum file size is 25MB per document.</em>
            </p>
        </div>
    );

    // Section 2: Reseller Certificate Uploader Card
    const renderResellerUpload = () => (
        <div className="upload-card-item">
            <div className="upload-card-header">
                <div className="upload-card-title">
                    <span className="upload-badge-num">1</span>
                    <span>Reseller certificate</span>
                </div>
                <span className="upload-required-tag">Required</span>
            </div>
            <div className="upload-card-body">
                <div className="upload-card-desc">
                    Attach your valid State Sales Tax Exemption Certificate, Resale Certificate, or Multi-Jurisdiction Exemption Form.
                </div>
                <input
                    type="file"
                    className="form-control"
                    id="upload_reseller_cert"
                    name="upload_reseller_cert"
                    accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                    onChange={(e) => onFileChange('upload_reseller_cert', e.target.files[0])}
                />
                {resellerFile && (
                    <div className="upload-file-display active">
                        <i className="fa fa-file-pdf text-danger fs-5"></i>
                        <span className="fw-bold">
                            {resellerFile.name} ({(resellerFile.size / 1024).toFixed(1)} KB)
                        </span>
                        <button
                            type="button"
                            className="btn-remove-file"
                            onClick={() => onRemoveFile('upload_reseller_cert')}
                            title="Remove file"
                        >
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                )}
            </div>
        </div>
    );

    // Section 3: Applicant Routing Summary
    const renderRoutingSummary = () => (
        <div className="p-3 bg-light border mb-4">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div>
                    <span className="fw-bold text-dark" style={{ fontSize: '13.5px' }}>Applicant Company:</span>
                    <span className="text-teal fw-bold ms-1">
                        {formData.company_name?.trim() || 'New Customer Account'}
                    </span>
                </div>
                <div className="small text-muted">
                    Transmitting documents directly to <strong>Billing@techtopind.com</strong>
                </div>
            </div>
        </div>
    );

    // Section 4: Action Buttons
    const renderNavigationActions = () => (
        <div className="form-actions-bar d-flex justify-content-between align-items-center">
            <button type="button" className="back-btn" onClick={() => onBack(1)}>
                <i className="fa fa-arrow-left me-1"></i> Back to Step 1
            </button>
            <button type="button" className="next-btn" onClick={() => onNext(3)}>
                Proceed to Step 3: Credit Terms <i className="fa fa-arrow-right ms-2"></i>
            </button>
        </div>
    );

    return (
        <div id="step_2_content">
            <div className="section-head-row mb-3">
                <h3 className="section-heading-text">
                    <i className="fa fa-cloud-upload-alt text-teal me-2"></i>Step 2: Upload Supporting Documents
                </h3>
            </div>

            {renderDocumentRequirements()}
            {renderResellerUpload()}
            {renderRoutingSummary()}
            {renderNavigationActions()}
        </div>
    );
};

export default Step2;
